import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
      width: 250,
    },
  },
};

export default function SelectInput({
  name,
  value,
  label,
  setValue,
  selectValues,
  style,
  itemValue,
  city,
}) {
  return (
    <FormControl style={style}>
      <InputLabel id="demo-simple-select-label">
        {label ? label : name}
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        fullWidth
        value={value}
        label={label ? label : name}
        onChange={(e) => setValue(e.target.value)}
        MenuProps={MenuProps}
      >
        {city
          ? selectValues?.map((item) => (
              <MenuItem key={`${item.id}-${item.name}`} value={item.city_id}>
                {item.city}
              </MenuItem>
            ))
          : selectValues?.map((item) => (
              <MenuItem
                key={`${item.id}-${item.name}`}
                value={itemValue ? item.value : item.id}
              >
                {item.name}
              </MenuItem>
            ))}
      </Select>
    </FormControl>
  );
}
